module.exports = __webpack_public_path__ + "media/img/prices/targeted-emails-b544156ced5d0bc2b12923bf248bd6bb.png";